export default function CookieLicense({ className = "" }) {
  return (
    <svg viewBox="0 0 132 96" className={className} aria-hidden="true" data-testid="cookie-license-illustration">
      <defs>
        <linearGradient id="cl-card" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#fdf2f6" />
          <stop offset="0.55" stopColor="#f3e3f0" />
          <stop offset="1" stopColor="#dbe7f8" />
        </linearGradient>
        <linearGradient id="cl-shine" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#fff" stopOpacity="0.7" />
          <stop offset="0.5" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <radialGradient id="cl-cookie" cx="0.4" cy="0.35" r="0.75">
          <stop offset="0" stopColor="#e0a35a" />
          <stop offset="1" stopColor="#a8622a" />
        </radialGradient>
        <mask id="cl-bite">
          <rect x="0" y="0" width="132" height="96" fill="#fff" />
          <circle cx="126" cy="66" r="10" fill="#000" />
          <circle cx="118" cy="57" r="4.5" fill="#000" />
        </mask>
      </defs>

      <g className="cl-card" transform="rotate(-6 60 50)">
        <rect x="8" y="16" width="104" height="66" rx="8" fill="#0B2545" opacity="0.35" transform="translate(3 5)" />
        <rect x="8" y="16" width="104" height="66" rx="8" fill="url(#cl-card)" stroke="#fff" strokeWidth="1.5" />
        <rect x="8" y="16" width="104" height="66" rx="8" fill="url(#cl-shine)" />
        <rect x="8" y="16" width="104" height="11" rx="8" fill="#1d4f9c" />
        <rect x="8" y="22" width="104" height="5" fill="#1d4f9c" />
        <text x="15" y="24.5" fontSize="6" fontWeight="800" fill="#ffce3a" fontFamily="ui-sans-serif, system-ui" letterSpacing="0.6">KÖRKORT</text>
        <text x="80" y="24.5" fontSize="4.5" fontWeight="700" fill="#fff" fontFamily="ui-sans-serif, system-ui" letterSpacing="0.4">SVERIGE</text>

        <rect x="15" y="33" width="24" height="30" rx="3" fill="#fff" stroke="#c9d6ea" />
        <circle cx="27" cy="44" r="5.5" fill="#0B2545" />
        <path d="M17.5 61 C18 53 36 53 36.5 61 Z" fill="#0B2545" />

        <rect x="45" y="35" width="36" height="3.2" rx="1.6" fill="#0B2545" opacity="0.85" />
        <rect x="45" y="42" width="52" height="2.6" rx="1.3" fill="#0B2545" opacity="0.35" />
        <rect x="45" y="48" width="44" height="2.6" rx="1.3" fill="#0B2545" opacity="0.35" />
        <rect x="45" y="54" width="30" height="2.6" rx="1.3" fill="#0B2545" opacity="0.35" />

        <rect x="15" y="68" width="42" height="2.6" rx="1.3" fill="#0B2545" opacity="0.25" />
        <rect x="45" y="61" width="14" height="10" rx="2.5" fill="#ffce3a" />
        <text x="52" y="68.6" fontSize="7" fontWeight="900" fill="#0B2545" textAnchor="middle" fontFamily="ui-sans-serif, system-ui">B</text>
        <path d="M100 66 l3 3 l5.5 -6" stroke="#16a34a" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </g>

      <g className="cl-cookie" mask="url(#cl-bite)">
        <circle cx="106" cy="72" r="20" fill="url(#cl-cookie)" />
        <circle cx="106" cy="72" r="20" fill="none" stroke="#7a4218" strokeWidth="1.2" opacity="0.6" />
        <circle cx="98" cy="66" r="2.6" fill="#4a2a12" />
        <circle cx="110" cy="62" r="2.2" fill="#4a2a12" />
        <circle cx="96" cy="78" r="2.3" fill="#4a2a12" />
        <circle cx="107" cy="76" r="2.8" fill="#4a2a12" />
        <circle cx="114" cy="84" r="1.9" fill="#4a2a12" />
        <circle cx="101" cy="86" r="1.6" fill="#4a2a12" />
      </g>
      <path d="M92 56 q1 -3 3 -1" stroke="#b07a48" strokeWidth="1.2" fill="none" strokeLinecap="round" opacity="0.6" />
      <circle cx="120" cy="50" r="1.4" fill="#a8622a" />
      <circle cx="125" cy="55" r="1" fill="#a8622a" />
    </svg>
  );
}
